'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var reactElements = require('@selfdetermine/react-elements');
var reactForms = require('@selfdetermine/react-forms');
var reactHooks = require('@selfdetermine/react-hooks');
var graphql = require('@selfdetermine/graphql');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    query Matters {\n      viewer {\n        matters(sort: {}) {\n          edges {\n            node {\n              id\n              kind\n              ledger {\n                id\n                charges {\n                  amount\n                  description\n                  createdAt\n                }\n                payments {\n                  amount\n                  paymentMethod\n                  createdAt\n                }\n                balance\n              }\n              createdAt\n            }\n          }\n        }\n      }\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      query Ledger($id: ID!) {\n        viewer {\n          matter(id: $id) {\n            ledger {\n              id\n              payments {\n                amount\n                paymentMethod\n                createdAt\n              }\n              charges {\n                amount\n                description\n                createdAt\n              }\n              balance\n            }\n          }\n        }\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    mutation(\n      $ledger: ID!\n      $amount: Float!\n      $paymentMethod: String!\n      $description: String!\n    ) {\n      addMatterPayment(\n        ledger: $ledger\n        amount: $amount\n        paymentMethod: $paymentMethod\n        description: $description\n      ) {\n        amount\n        paymentMethod\n        createdAt\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    mutation(\n      $ledger: ID!\n      $amount: Float!\n      $paymentMethod: String!\n      $description: String!\n    ) {\n      addMatterPayment(\n        ledger: $ledger\n        amount: $amount\n        paymentMethod: $paymentMethod\n        description: $description\n      ) {\n        amount\n        paymentMethod\n        createdAt\n      }\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    mutation(\n      $matter: ID!\n      $amount: Float!\n      $description: String!\n      $payor: ID!\n    ) {\n      addMatterCharge(\n        matter: $matter\n        amount: $amount\n        description: $description\n        payor: $payor\n      ) {\n        amount\n        description\n        createdAt\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation(\n      $matter: ID!\n      $amount: Float!\n      $description: String!\n      $payor: ID!\n    ) {\n      addMatterCharge(\n        matter: $matter\n        amount: $amount\n        description: $description\n        payor: $payor\n      ) {\n        amount\n        description\n        createdAt\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var useCreate = function useCreate() {
  var _useMutation = reactHooks.useMutation(graphql.gql(_templateObject())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(ledger) {
    return mutate({
      variables: _objectSpread2({}, ledger)
    });
  };

  return [create, meta];
};

var useCreateMatterCharge = function useCreateMatterCharge() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      matter = _ref.matter;

  var _useMutation3 = reactHooks.useMutation(graphql.gql(_templateObject2())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var create = function create() {
    var _form$payor;

    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return mutate({
      variables: _objectSpread2(_objectSpread2({}, form), {}, {
        matter: matter === null || matter === void 0 ? void 0 : matter.id,
        amount: Number(form === null || form === void 0 ? void 0 : form.amount),
        payor: form === null || form === void 0 ? void 0 : (_form$payor = form.payor) === null || _form$payor === void 0 ? void 0 : _form$payor.id
      })
    });
  };

  return [create, meta];
};

var useCreateLedgerPayment = function useCreateLedgerPayment() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ledger = _ref2.ledger;

  var _useMutation5 = reactHooks.useMutation(graphql.gql(_templateObject3())),
      _useMutation6 = _slicedToArray(_useMutation5, 2),
      mutate = _useMutation6[0],
      meta = _useMutation6[1];

  var create = function create() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return mutate({
      variables: _objectSpread2(_objectSpread2({}, form), {}, {
        ledger: ledger === null || ledger === void 0 ? void 0 : ledger.id,
        amount: Number(form === null || form === void 0 ? void 0 : form.amount)
      })
    });
  };

  return [create, meta];
};

var useUpdate = function useUpdate() {
  var _useMutation7 = reactHooks.useMutation(graphql.gql(_templateObject4())),
      _useMutation8 = _slicedToArray(_useMutation7, 2),
      mutate = _useMutation8[0],
      meta = _useMutation8[1];

  var update = function update(_ref3) {
    var amount = _ref3.amount,
        ledger = _objectWithoutProperties(_ref3, ["amount"]);

    return mutate({
      variables: _objectSpread2({
        amount: parseFloat(amount)
      }, ledger)
    });
  };

  return [update, meta];
}; // represented as a ledger over a matter.

/**
   @param id matter id
*/


var useLedger = function useLedger() {
  var _query$data, _query$data$viewer, _query$data$viewer$ma;

  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref4.id;

  var query = reactHooks.useQuery(graphql.gql(_templateObject5()), {
    variables: {
      id: id
    }
  });
  return [query === null || query === void 0 ? void 0 : (_query$data = query.data) === null || _query$data === void 0 ? void 0 : (_query$data$viewer = _query$data.viewer) === null || _query$data$viewer === void 0 ? void 0 : (_query$data$viewer$ma = _query$data$viewer.matter) === null || _query$data$viewer$ma === void 0 ? void 0 : _query$data$viewer$ma.ledger, query];
};
var useLedgers = function useLedgers() {
  var _query$data2, _query$data2$viewer;

  var query = reactHooks.useQuery(graphql.gql(_templateObject6()));
  return [(query === null || query === void 0 ? void 0 : (_query$data2 = query.data) === null || _query$data2 === void 0 ? void 0 : (_query$data2$viewer = _query$data2.viewer) === null || _query$data2$viewer === void 0 ? void 0 : _query$data2$viewer.matters.edges.filter(function (_ref5) {
    var node = _ref5.node;
    return !!node.ledger;
  }).map(function (_ref6) {
    var node = _ref6.node;
    return _objectSpread2({
      matter: node
    }, node.ledger);
  })) || [], query];
};
var MatterLedgerChargeForm = function MatterLedgerChargeForm(_ref7) {
  var matter = _ref7.matter,
      onDone = _ref7.onDone,
      onError = _ref7.onError,
      onCancel = _ref7.onCancel;

  var _useCreateMatterCharg = useCreateMatterCharge({
    matter: matter
  }),
      _useCreateMatterCharg2 = _slicedToArray(_useCreateMatterCharg, 2),
      create = _useCreateMatterCharg2[0],
      meta = _useCreateMatterCharg2[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return create(form);

            case 3:
              response = _context.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (typeof onError === "function") {
                onError(_context.t0);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onSubmit(_x) {
      return _ref8.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    loading: meta.loading,
    error: meta.error,
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "amount",
    label: "Amount",
    type: "number",
    step: "0.01",
    min: "0.01",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "description",
    label: "Description",
    type: "text",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "payor",
    label: "Payment required by",
    type: "person",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Add charge")))));
};
MatterLedgerChargeForm.propTypes = {
  matter: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string.isRequired
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func
};
var LedgerPaymentForm = function LedgerPaymentForm(_ref9) {
  var ledger = _ref9.ledger,
      onDone = _ref9.onDone,
      onError = _ref9.onError,
      onCancel = _ref9.onCancel;

  var _useCreateLedgerPayme = useCreateLedgerPayment({
    ledger: ledger
  }),
      _useCreateLedgerPayme2 = _slicedToArray(_useCreateLedgerPayme, 2),
      create = _useCreateLedgerPayme2[0],
      meta = _useCreateLedgerPayme2[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(form) {
      var response;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return create(form);

            case 3:
              response = _context2.sent;

              if (typeof onDone === "function") {
                onDone(response);
              }

              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);

              if (typeof onError === "function") {
                onError(_context2.t0);
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function onSubmit(_x2) {
      return _ref10.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    loading: meta.loading,
    error: meta.error,
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "amount",
    label: "Amount",
    type: "number",
    step: "0.01",
    min: "0.01",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "paymentMethod",
    label: "Payment Method",
    type: "text",
    required: true,
    list: "ledgerPaymentMethods"
  }), /*#__PURE__*/React__default['default'].createElement("datalist", {
    id: "ledgerPaymentMethods"
  }, /*#__PURE__*/React__default['default'].createElement("option", {
    value: "Cash"
  }), /*#__PURE__*/React__default['default'].createElement("option", {
    value: "Credit Card"
  }), /*#__PURE__*/React__default['default'].createElement("option", {
    value: "Debit Card"
  })), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "description",
    label: "Description",
    type: "text",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, "Add payment")))));
};
LedgerPaymentForm.propTypes = {
  ledger: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string.isRequired
  }).isRequired,
  onDone: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func
};
var LedgerForm = function LedgerForm(_ref11) {
  var ledger = _ref11.ledger,
      onDone = _ref11.onDone,
      onError = _ref11.onError,
      onCancel = _ref11.onCancel,
      defaultValues = _ref11.defaultValues;

  var _useCreate = useCreate(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var _useUpdate = useUpdate(),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      updateMeta = _useUpdate2[1];

  var isCreate = !(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id);
  var isLoading = createMeta.loading || updateMeta.loading;
  var error = createMeta.error || updateMeta.error;
  return /*#__PURE__*/React__default['default'].createElement(reactForms.Form, {
    loading: isLoading,
    error: error,
    defaultValues: defaultValues,
    onSubmit: /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref12) {
        var amount, description, payor, paymentMethod, _ledger$matter;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                amount = _ref12.amount, description = _ref12.description, payor = _ref12.payor, paymentMethod = _ref12.paymentMethod;
                _context3.prev = 1;

                if (!isCreate) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 5;
                return create({
                  matter: ledger === null || ledger === void 0 ? void 0 : (_ledger$matter = ledger.matter) === null || _ledger$matter === void 0 ? void 0 : _ledger$matter.id,
                  amount: parseFloat(amount),
                  description: description,
                  payor: payor === null || payor === void 0 ? void 0 : payor.id
                });

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.next = 9;
                return update({
                  ledger: ledger === null || ledger === void 0 ? void 0 : ledger.id,
                  amount: amount,
                  description: description,
                  paymentMethod: paymentMethod
                });

              case 9:
                if (typeof onDone === "function") {
                  onDone();
                }

                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](1);

                if (typeof onError === "function") {
                  onError(_context3.t0);
                }

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 12]]);
      }));

      return function (_x3) {
        return _ref13.apply(this, arguments);
      };
    }()
  }, isCreate ? /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "payor",
    label: "Payor",
    type: "person"
  }) : /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "paymentMethod",
    label: "Payment Method",
    type: "text"
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "description",
    label: "Description",
    type: "text",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactForms.Form.Input, {
    name: "amount",
    label: "Amount",
    type: "number",
    step: "0.01",
    min: "0.01",
    required: true
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Item, null, /*#__PURE__*/React__default['default'].createElement(reactForms.Form.SubmitButton, null, isCreate ? "Add Charge" : "Add Payment")))));
};
LedgerForm.propTypes = {
  onDone: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  onCancel: PropTypes__default['default'].func,
  ledger: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    balance: PropTypes__default['default'].number,
    matter: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].string
    }),
    charges: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      amount: PropTypes__default['default'].number,
      description: PropTypes__default['default'].string,
      createdAt: PropTypes__default['default'].date
    })),
    payments: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      amount: PropTypes__default['default'].number,
      paymentMethod: PropTypes__default['default'].string,
      createdAt: PropTypes__default['default'].date
    }))
  }).isRequired,
  defaultValues: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].number,
    name: PropTypes__default['default'].string
  })
};
var LedgerCard = function LedgerCard(_ref14) {
  var ledger = _ref14.ledger;
  return /*#__PURE__*/React__default['default'].createElement(reactElements.Card, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Header, {
    title: [ledger.id, ledger.balance ? new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(ledger.balance) : null].filter(Boolean).join(" - ")
  }));
};
LedgerCard.propTypes = {
  ledger: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    balance: PropTypes__default['default'].number,
    charges: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      amount: PropTypes__default['default'].number,
      description: PropTypes__default['default'].string,
      createdAt: PropTypes__default['default'].date
    })),
    payments: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
      amount: PropTypes__default['default'].number,
      paymentMethod: PropTypes__default['default'].string,
      createdAt: PropTypes__default['default'].date
    }))
  }).isRequired
};

exports.LedgerCard = LedgerCard;
exports.LedgerForm = LedgerForm;
exports.LedgerPaymentForm = LedgerPaymentForm;
exports.MatterLedgerChargeForm = MatterLedgerChargeForm;
exports.useLedger = useLedger;
exports.useLedgers = useLedgers;
